import { ACTION_TYPE } from './useHolidayApi';

const initialState = {
  data: {},
  loading: false,
  error: false,
};

export const reducerHolidayApi = {
  [ACTION_TYPE]: (state = initialState, action) => {
    switch (action.type) {
      case `${ACTION_TYPE}_CALLED`:
        return {
          ...state,
          loading: true,
          error: false,
        };
      case `${ACTION_TYPE}_COMPLETED`:
        return {
          ...state,
          data: action.payload,
          loading: false,
          error: false,
        };
      case `${ACTION_TYPE}_ERROR`:
        return {
          ...state,
          loading: false,
          error: true,
          data: action.payload,
        };
      default:
        return state;
    }
  },
};
